import { API } from "apis";
import { message } from "antd";
import { DefaultOptionType } from "antd/es/select";
import { UploadFile } from "antd/es/upload/interface";
import { Dispatch, SetStateAction } from "react";
import { SERVER_URL } from "../constants/constants";
import { del, getViaAuth, postViaAuth, responseValidator } from "../../apis/api";
import { Enum } from "../domain";
import { AddPopUp } from "../domain/popups/popups";

export const getAllPopUps = (
    setloader: any,
    setdata: any,
    page: number,
    pageSize: number,
    query: string
) => {
    setloader(true);
    getViaAuth(`${API.popUp.getAll}/${page}/${pageSize}${query || ""}`).then(
        (response: any) => {
            setloader(false);
            if (responseValidator(response.status)) {
                console.log(response)
                setdata(response.value);
            }
        }
    );
};

function base64ToArrayBuffer(base64: any) {
    var binaryString = atob(base64.split(",")[1]);
    var bytes = new Uint8Array(binaryString.length);
    for (var i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}

export const getPopUpById = async (
    setloader: any,
    setdata: any,
    setselectedoptions: React.Dispatch<React.SetStateAction<DefaultOptionType[]>>,
    id: string
) => {
    let popupData: any = {};
    let mapLevels = [];
    setloader(true);
    await getViaAuth(API.popUp.getById + `/${id}`).then(async (response: any) => {
        setloader(false);
        if (responseValidator(response.status)) {
            let xa: UploadFile = {
                uid: id,
                name: "rrr",
            };
            Object.assign(popupData, {
                title: response.value.title,
                description: response.value.description,
                intervalView: response.value.intervalView,
                forLevelIds: response.value.forLevelUniqname?.map((i: any) =>
                    i.id.toString()
                ),
                file: response.value.file,
                viewAfterSecond: response.value.viewAfterSecond,
                viewCount: response.value.viewCount,
                isActive: response.value.isActive,
                urlPage: response.value.urlPage,
                linkTo: response.value.linkTo,
                imageUrl: `${SERVER_URL}${response.value.imageUrl}`,
                platform: response.value.platform?.id ?? -1,
            });

            mapLevels = response.value.forLevelUniqname?.map((i: Enum) => ({
                label:
                    i.id == 1
                        ? "سطح پایه"
                        : i.id == 2
                            ? "سطح 1"
                            : i.id == 3
                                ? "سطح 2"
                                : i.id == 4
                                    ? "سطح 3"
                                    : i.id == 5
                                        ? "سطح 4"
                                        : "",
                value: i.id,
            }));
            setselectedoptions(mapLevels);
            setdata(popupData);

            if (response.value.imageUrl) {
                const base64 = await fetch(popupData.imageUrl)
                    .then((response) => response.blob())
                    .then((blob) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(blob);
                        return new Promise((res) => {
                            reader.onloadend = () => {
                                res(reader.result);
                            };
                        });
                    });
                popupData.file = base64;
                const file = new File(
                    [base64ToArrayBuffer(base64)],
                    `${response.value.imageUrl
                        .split("/")
                    [response.value.imageUrl.split("/").length - 1].split(".")[0]
                    }`
                );
                setdata({ ...popupData, file });
            }
        }
    });
};

export const updatePopUp = (
    setLoader: any,
    data: AddPopUp | undefined,
    selectedOptions: DefaultOptionType[],
    id: string,
    newImageUploaded: boolean
) => {
    let levelIds = selectedOptions?.map((item: any) => item.value);
    setLoader(true);
    const formData = new FormData();
    formData.append("id", id);
    if (newImageUploaded && data?.file) {
        formData.append("file", data.file);
    }
    data?.title && formData.append("Title", data.title);
    data?.description && formData.append("Description", data.description);
    data?.urlPage && formData.append("UrlPage", data.urlPage);
    data?.linkTo && formData.append("LinkTo", data.linkTo);
    data?.viewAfterSecond && formData.append("ViewAfterSecond", data.viewAfterSecond.toString());
    data?.viewCount && formData.append("ViewCount", data.viewCount.toString());
    data?.intervalView && formData.append("IntervalView", data.intervalView.toString());
    selectedOptions &&
        levelIds.forEach((i) => formData.append("ForLevelIds[]", i));
    data?.isActive !== undefined && formData.append("isActive", data.isActive.toString());
    // نفرستادن Platform یعنی پاپ آپ برای همه‌ی پلتفرم‌ها
    data?.platform && data.platform !== -1 && formData.append("Platform", data.platform.toString());

    postViaAuth(API.popUp.edit, formData, true).then((response: any) => {
        setLoader(false);
        if (responseValidator(response.status)) {
            message.success(response.message);
        } else {
            message.error(response.message);
        }
    });
}

export const addPopUp = (
    setloader: any,
    data: AddPopUp | undefined,
    selectedOptions: DefaultOptionType[],
    onSuccess: any
) => {
    console.log({ selectedOptions })
    let mappedOptions = selectedOptions?.map((i: any) => ({
        id: i.value || "",
        title: i.label || "",
    }));
    let levelIds = selectedOptions?.map((item: any) => item.value);
    setloader(true);
    const fromForm = new FormData();
    data?.file && fromForm.append("File", data.file);
    data?.title && fromForm.append("Title", data.title);
    data?.description && fromForm.append("Description", data.description);
    data?.urlPage && fromForm.append("UrlPage", data.urlPage);
    data?.linkTo && fromForm.append("LinkTo", data.linkTo);
    data?.viewAfterSecond &&
        fromForm.append("ViewAfterSecond", data.viewAfterSecond);
    data?.viewCount && fromForm.append("ViewCount", data.viewCount);
    data?.intervalView && fromForm.append("IntervalView", data.intervalView);
    data?.isActive && fromForm.append("isActive", data.isActive.toString());
    data?.platform && data.platform !== -1 && fromForm.append("Platform", data.platform.toString());
    selectedOptions &&
        levelIds.forEach((i) => fromForm.append("ForLevelIds[]", i));

    postViaAuth(API.popUp.add, fromForm, true).then((response: any) => {
        setloader(false);
        if (responseValidator(response.status)) {
            message.success(response.message);
            onSuccess();
        }
    });
};

export const deletePopup = (
    setLoading: Dispatch<SetStateAction<boolean>>,
    popupId: number,
    onComplete: () => void
) => {
    setLoading(true);
    postViaAuth(API.popUp.delete, { id: popupId }).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            onComplete();
        }
    });
};
